import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Moon, Sun, List, X, ArrowRight } from '@phosphor-icons/react';
import { useTheme } from '@/contexts/ThemeContext';

export default function PublicNav() {
  const navigate = useNavigate();
  const { theme, toggleTheme } = useTheme();
  const [mobileMenu, setMobileMenu] = useState(false);

  return (
    <>
      <header>
        <nav
          role="navigation"
          aria-label="Main navigation"
          className="fixed top-0 left-0 right-0 z-50 h-16 flex items-center justify-between px-6 lg:px-12 border-b border-transparent"
          style={{
            backdropFilter: 'blur(24px) saturate(1.3)',
            WebkitBackdropFilter: 'blur(24px) saturate(1.3)',
            backgroundColor: theme === 'dark' ? 'rgba(15,15,15,0.85)' : 'rgba(247,246,243,0.85)',
          }}
        >
          <Link to="/" className="flex items-center gap-2.5">
            <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{ backgroundColor: '#E04B2A' }}>
              <span className="text-xs font-extrabold text-white font-display">A</span>
            </div>
            <span className="font-display font-bold text-lg tracking-tight text-foreground">Admitrix</span>
          </Link>
          <div className="hidden md:flex items-center gap-8">
            <a href="/#features" className="text-[13px] text-muted-foreground hover:text-foreground transition-colors">Features</a>
            <a href="/#screenshots" className="text-[13px] text-muted-foreground hover:text-foreground transition-colors">Product</a>
            <Link to="/docs" className="text-[13px] text-muted-foreground hover:text-foreground transition-colors">Docs</Link>
            <Link to="/pricing" className="text-[13px] text-muted-foreground hover:text-foreground transition-colors">Pricing</Link>
          </div>
          <div className="flex items-center gap-3">
            <button onClick={toggleTheme} className="p-2 hover:bg-secondary rounded-lg transition-colors text-muted-foreground">
              {theme === 'dark' ? <Sun size={16} weight="bold" /> : <Moon size={16} weight="bold" />}
            </button>
            <button onClick={() => navigate('/login')} className="text-[13px] text-muted-foreground hover:text-foreground transition-colors hidden sm:block">Sign in</button>
            <button onClick={() => navigate('/contact')} className="hidden sm:flex h-9 px-5 rounded-lg text-[13px] font-bold text-white items-center gap-1.5 transition-transform hover:scale-[1.02]" style={{ backgroundColor: '#E04B2A' }}>
              Get Started <ArrowRight size={14} weight="bold" />
            </button>
            <button onClick={() => setMobileMenu(!mobileMenu)} className="md:hidden p-2 text-foreground">
              {mobileMenu ? <X size={20} /> : <List size={20} />}
            </button>
          </div>
        </nav>
        {mobileMenu && (
          <div className="fixed inset-0 z-40 bg-background pt-20 px-6 flex flex-col gap-6 md:hidden">
            <a href="/#features" onClick={() => setMobileMenu(false)} className="text-lg font-display font-bold">Features</a>
            <Link to="/docs" onClick={() => setMobileMenu(false)} className="text-lg font-display font-bold">Docs</Link>
            <Link to="/pricing" onClick={() => setMobileMenu(false)} className="text-lg font-display font-bold">Pricing</Link>
            <Link to="/contact" onClick={() => setMobileMenu(false)} className="text-lg font-display font-bold">Contact</Link>
            <button onClick={() => { navigate('/contact'); setMobileMenu(false); }} className="h-12 rounded-lg text-sm font-bold text-white mt-4" style={{ backgroundColor: '#E04B2A' }}>Get Started</button>
          </div>
        )}
      </header>
    </>
  );
}
